/**
 * Helper to find the preferred color ID
 * @param {Object} hit - The product hit object from Algolia
 * @param {Object} categoryImage - The category image object from Algolia
 * @returns {number|null} - The preferred color ID for the category or null
 */
export function findPreferredColorId(hit, categoryImage) {
  if (!categoryImage?.preferred_color_id || !hit.colors) return null;

  const matchingColor = hit.colors.find(
    (col) => col.id === categoryImage.preferred_color_id
  );

  return matchingColor ? matchingColor.id : null;
}

/**
 * Get the quotable product ID in a single method
 * Handles finding the preferred color ID and determining the appropriate quotable product ID
 *
 * @param {Object} hit - The product hit object from Algolia
 * @param {number} categoryId - The category ID to find preferred color for
 * @returns {number} - The product ID to use for quotes
 */
export function getInitialSelectedColorId(hit, categoryId) {
  const categoryImage = hit?.category_images?.find(
    (cat) => cat.id == categoryId
  );
  const preferredColorId = findPreferredColorId(hit, categoryImage);

  return preferredColorId || hit?.colors?.[0]?.id || hit?.product_id;
}
